var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"detection-label",class:_vm.wrapperClasses},[_c('div',{staticClass:"detection-label__content",style:(_vm.labelStyles)},[_vm._t("default",function(){return [_vm._v("\n      "+_vm._s(_vm.formattedLabel)+"\n    ")]},null,{ textColor: _vm.textColor, backgroundColor: _vm.backgroundColor })],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }